import { AlpineComponent } from 'alpinejs';
import { CountUp } from 'countup.js';

type InfoTilesData = {};

export default (): AlpineComponent<InfoTilesData> => ({
  init() {
    const container = this.$el as HTMLElement;
    const gridItems = container.querySelectorAll<HTMLElement>(
      '.ce-info-tiles-section-grid-item'
    );

    gridItems.forEach((gridItem) => {
      const kpiEl = gridItem.querySelector<HTMLElement>(
        '.ce-info-tiles-kpi-value'
      );
      if (!kpiEl) return;

      const raw = kpiEl.getAttribute('data-kpi-value');
      if (raw === null || raw === '') return;

      const num = parseFloat(raw);
      if (Number.isNaN(num)) return;

      kpiEl.textContent = '0';

      const isDecimal = num % 1 !== 0;
      const decimalPlaces = isDecimal
        ? (String(raw).split(/[.,]/)[1]?.length ?? 3)
        : 0;

      const countUp = new CountUp(kpiEl, num, {
        startVal: 0,
        duration: 2,
        decimalPlaces,
        useGrouping: true,
        separator: '.',
        decimal: isDecimal ? ',' : '.',
      });

      if (countUp.error) {
        kpiEl.textContent = raw;
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              countUp.start();
              observer.unobserve(entry.target);
            }
          });
        },
        {
          rootMargin: '-10% 0%',
          threshold: 0.1,
        }
      );

      observer.observe(gridItem);
    });
  },
});
